export const substring = (string: string, length: number) => {
  let sub = string.slice(0, length + 1);

  if (sub.length < string.length) {
    sub = sub.slice(0, sub.length + 1);
  }
  return sub.length < string.length ? `${sub} ...` : sub;
};

export const formatNumber = (value: string) => {
  value = value.replace(/[, ]+/g, '').trim();
  let numberPattern = /\d+/g;
  const number = value.match(numberPattern) ?? 0;
  return Number(number);
};

export const getNumbers = (value: string) => {
  const numbers = value.replace(/[$,]/g, '');

  return numbers;
};
